module.exports = __webpack_public_path__ + "static/img/_lucilas-1.c4bd1b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/_lucilas-1.jpg
// module id = aYpj
// module chunks = 1